<template>
  <div class="relevance">
    <div class="text">{{ $t('search.relevance') }}</div>
    <div class="max-score"
         :class="barBgColor"></div>
    <div :style="`width:${scoreWidth}px`"
         class="bar-height"
         :class="color"></div>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
    },
    maxScore: { type: Number },
    color: {
      type: String,
    },
    barBgColor: {
      type: String,
    },
  },
  computed: {
    scoreWidth() {
      return Math.min(100, (100 * this.score) / this.maxScore);
      //return Math.min(100, 100 * this.score);
    },
  },
};
</script>

<style scoped>
.relevance {
  height: 10px;
  width: 100px;
  width: 120px !important;
  margin-top: -6px;
  border-radius: 6px;
}
.text {
  font-size: 0.6rem;
  padding-bottom: 3px;
  color: grey;
}
.max-score {
  height: 3px;
  width: 100px;
}
.bar-height {
  height: 3px;
  margin-top: -3px;
}
</style>
